import axios from "axios";
import AuthService from "../auth/auth_service";
// import { gerarUrl } from "../../utilities/utils/Pageable";

export default class SectorService extends AuthService {
  findByLocal(localId) {
    return axios({
      method: "GET",
      url: this.api_url_intra + "sector/local/" + localId,
      withCredentials: true,
    }).then((res) => res.data);
  }
  findBySectorId(sectorId) {
    return axios({
      method: "GET",
      url: this.api_url_intra + "sector/" + sectorId,
      withCredentials: true,
    }).then((res) => res.data);
  }

  findAllByFilter(acronym) {
    return axios({
      method: "get",
      url: `${this.api_url_intra}sector?acronym=${acronym}`,
      withCredentials: true,
    }).then((res) => res.data);
  }
}
